// 追従(CookiePolicy)の表示 // Display follow (CookiePolicy)
jQuery(function($) {

	if ( $('#cookiePolicy').length > 0 ) {
		var cookiePolicy = $('#cookiePolicy');
		cookiePolicy.hide();
		if(localStorage.getItem('cookieUse') === null) {

			// スクロール時の表示・非表示 // show/hide on scrolling
			$(window).on("scroll", dispAgree);

			// 同意ボタンクリック // click on the agree button
			$('#cookie_agree').on("click", function() {
				$(window).off("scroll", dispAgree);
				localStorage.setItem('cookieUse', 'agree');
				cookiePolicy.hide();
			})
		}

		//スクロールが100に達したらクッキー同意を表示 // Show cookie agreement when scroll reaches 100
		function dispAgree() {
			if ($(this).scrollTop() > 100) {
				cookiePolicy.fadeIn();
			} else {
				cookiePolicy.fadeOut();
			}
		}
	}


});

// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

// ページトップボタンの表示 // Display the page top button
jQuery(function($) {

	if ( $('#pageup').length > 0 ) {
		var topBtn = $('#pageup');
		topBtn.css("display", "none");
		//スクロールが100に達したらボタン表示 // display button when scroll reaches 100
		$(window).scroll(function () {
			if ($(this).scrollTop() > 100) {
				topBtn.fadeIn();
			} else {
				topBtn.fadeOut();
			}
		});
		//スクロールしてトップ // scroll to the top
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});





// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 500);
		});
	}
});


// ドロワーメニュー // Drawer menu
jQuery(function($) {

	const $hamburger = $('.js-hamburger');
	const $header = $('.l-header');
	const $drawer = $('.p-drawer');
	const $body = $('body');

	function toggleDrawer(explicitClose = false) {
		const expanded = $hamburger.attr('aria-expanded') === 'true';
		const newExpanded = explicitClose ? false : !expanded;
		$hamburger.attr('aria-expanded', newExpanded);
		$header.toggleClass('is-drawer-open', newExpanded);
		$drawer.attr('aria-hidden', !newExpanded);
		$body.toggleClass('is-fixed', newExpanded);
	}

	$hamburger.on('click', function() {
		toggleDrawer();
	});

	$drawer.find('a').on('click', function() {
		toggleDrawer(true);
	});
	
});


// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});

jQuery(function ($) {
//二重送信抑制
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	// 入力項目にエラーがあったらボタン復活
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
		submitBtn.css('opacity', '1');
	}, false);
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-accordion-title').forEach(function(title) {
    title.addEventListener('click', function() {
      title.classList.toggle('is-open');
      var content = title.nextElementSibling;
      content.classList.toggle('is-open');
    });
  });
});

// 募集要項
jQuery(function($){
	let $tab = $('.p-info__tabs [data-job]');
    let $block = $('.p-info__blocks [data-job-category]');
   
    $tab.on('click',function(){
        $tab.removeClass('is-active');
        $(this).addClass('is-active');
        let $tabCat = $(this).attr('data-job');
        $block.fadeOut().promise().done(function() {
			$block.filter('[data-job-category = "' + $tabCat + '"]').fadeIn();
		});
        return false;
    });
});

// Contact Form 7: URLパラメータに応じてラジオボタンを自動選択
jQuery(function($){
	// URLパラメータを取得
	const urlParams = new URLSearchParams(window.location.search);
	const type = urlParams.get('type');
	
	if (type === 'recruit') {
		const checkAndSelect = function() {
			const recruitRadio = $('input[type="radio"][name="inquiry"][value="採用についてのお問い合わせ・ご応募"]');
			if (recruitRadio.length > 0) {
				recruitRadio.prop('checked', true);
			}
		};
		
		checkAndSelect();
		document.addEventListener('wpcf7ready', checkAndSelect, false);
	}
});
